module.exports = __webpack_public_path__ + "img/icon-edit.d01f15d7.svg";